import { AnimatePresence } from 'framer-motion';

import { Table, TableBody, TableHead, TableHeader, TableRow } from '@nesso/ui/primitives/table';

import type { Service } from '@/entities/service-catalog';

import { ServicesTableRow } from './services-table/services-table-row';

type Props = {
    services: Service[];
    highlightedCode?: string | null;
    onEdit: (service: Service) => void;
};

export function ServicesTable({ services, highlightedCode, onEdit }: Props) {
    return (
        <Table>
            <TableHeader>
                <TableRow>
                    <TableHead variant="plain" className="w-20 xs:w-26">
                        Code
                    </TableHead>
                    <TableHead variant="plain">Description</TableHead>
                    <TableHead variant="plain" className="hidden w-25 text-right xs:table-cell">
                        Rate
                    </TableHead>
                    <TableHead variant="plain" className="w-12">
                        <span className="sr-only">Actions</span>
                    </TableHead>
                </TableRow>
            </TableHeader>
            <TableBody>
                <AnimatePresence initial={false}>
                    {services.map((service) => (
                        <ServicesTableRow
                            key={service.code}
                            service={service}
                            highlighted={service.code === highlightedCode}
                            onEdit={onEdit}
                        />
                    ))}
                </AnimatePresence>
            </TableBody>
        </Table>
    );
}
